<template>
    <div class="v-atlas-map-module-info">
        <div></div>

    </div>
</template>

<script setup lang="ts">
import { AtlasMapModule } from "@/mapModules/AtlasMapModule";
import { ViewStackController } from "gertrud";



const props = defineProps<{
    mapModule: AtlasMapModule
    vsc: ViewStackController
}>()




</script>
